module.exports = __webpack_public_path__ + "static/28d-card-bg-d5fb77273ff54a768a556d9b363250a7.png";